import { date } from 'quasar'

function dateIsEligibleForVatDiscount (testDate) {
  const dateFrom = new Date(2020, 6, 1)
  const dateTo = new Date(2020, 11, 31)

  return date.isBetweenDates(testDate, dateFrom, dateTo, { inclusiveFrom: true, inclusiveTo: true })
}

function itemsContainDiscountVatRate (items) {
  for (let i = 0; i < items.length; i++) {
    if (items[i].salesTax === 16 || items[i].salesTax === 5) {
      return true
    }
  }

  return false
}

export { dateIsEligibleForVatDiscount, itemsContainDiscountVatRate }
